import React from "react";
import { Row, SubTitle, Title } from "../../common";

const TableTitle = ({ title, subTitle }) => (
  <Row style={{ gap: "1em" }}>
    <Title>{title}</Title>
    <SubTitle>{subTitle}</SubTitle>
  </Row>
);

export default TableTitle;
